import Papa from 'papaparse';

// Function to fetch and parse CSV data...
// utils/DataUtils.js

export const getCSVData = async (filePath) => {
  try {
    const response = await fetch(filePath);
    if (!response.ok) {
      throw new Error(`Failed to fetch CSV file: ${response.statusText}`);
    }
    const csvText = await response.text();
    //console.log("CSV Data: ", csvText);  // Log the raw CSV data
    return Papa.parse(csvText, { header: true }).data;
  } catch (error) {
    console.error('Error fetching CSV data:', error);
    return [];  // Return empty array in case of error
  }
};


// Function to fetch and parse JSON data...
// export const getJSONData = async (jsonFilePath) => {
//   try {
//     // Dynamically import the JSON file using the path provided
//     //const jsonData = await import(`${jsonFilePath}`);
//     const jsonData = await import(require.resolve(jsonFilePath));
    
//     // Return the data from the imported JSON (use `.default` because it's a default export)
//     return { success: true, data: jsonData.default };
//   } catch (error) {
//     console.error('Error loading JSON data:', error);
//     return { success: false, data: [] };  // Return an empty array in case of error
//   }
// };

export const getJSONData = async (jsonFilePath) => {
  let jsonData = [];
  try {
    const response = await fetch(jsonFilePath);
    if (!response.ok) {
      throw new Error(`Failed to fetch JSON file: ${response.statusText}`);
    }
    jsonData = await response.json();
  } catch (error) {
    console.error('Error loading JSON file:', error);
  }
  return jsonData;
};

// Function to determine the file type based on the file extension
export const getFileTypeFromPath = (filePath) => {
  const fileExtension = filePath.split('.').pop().toLowerCase();
  if (fileExtension === 'csv') return 'csv';
  if (fileExtension === 'json') return 'json';
  // Add more file types as needed in the future
  throw new Error(`Unsupported file type: .${fileExtension}`);
};
